import { IFontWeights } from './typography.types';

const fontWeights: IFontWeights = {
  normal: '400',
  semibold: '600',
  bold: '700',
};

export default fontWeights;
